import { TipologiasInterface } from "app/models/tipologias.model"

export class GenerarDocuentoInterface {
  tipoDocumento: TipologiasInterface
  CodigoDocumento?:number
  vigencia: number
  bienCulturalUuid: string
  generadoPor:string
  GestionesUuid: string[]
  plantillaId?: number
}